module.exports = __webpack_public_path__ + "img/CONSTRUIR.c70746f3.png";